<template>
	<div class="flex-grow-1-scroll h-100 no-gutters provider-content" ref="container">
		<div class='d-flex flex-column h-100'>
			<loading ref="loading"></loading>

			<header class="p-2 header__dashboard--top" style="z-index: 100;">
				<h1 class="h2" style="">{{ $t('translations.settings')}}</h1>
			</header>

			<div class='flex-grow-1-scroll h-100 p-2' style="">

				<local-error v-bind:inline='["availability_date,blood_pressure.*"]'></local-error>

				<div class="d-flex justify-content-between flex-wrap align-items-baseline">

<!-- Service status -->
				<div class="p-3 col-lg-16 col-md-24 col-sm-24 bg-white br-1 m-1">
					<h3>{{ $t('translations.service_status')}}</h3>
					<hr>
					<div class="d-flex justify-content-between">

						<label class="col-15 col-form-label" v-if="is_superuser() || is_admin()"><span class="justify-content-between align-self-center">{{ $t('translations.set_service_availability')}}</span></label>
						<label class="col-15 col-form-label" v-else><span class="justify-content-between align-self-center">{{ $t('translations.availability_of_the_service')}}</span></label>

						<label v-if='is_superuser() || is_admin()' class='toggle-label-sm justify-content-between align-items-center ml-auto'>
							<input v-model='provider.service_status' type='checkbox' />
								<span class='back'>
								<span class='toggle'></span>
								<span class='label on'>{{ $t('translations.on')}}</span>
								<span class='label off'>{{ $t('translations.off')}}</span>
							</span>
						</label>
						<span v-else>
							<span v-if='provider.service_status == 1' class="labelOn">{{ $t('translations.on')}}</span>
							<span v-else-if=' provider.service_status == 0' class="labelOff">{{ $t('translations.off')}}</span>
						</span>
					</div>

					<hr>

					<div class="form-group d-flex justify-content-between bg-white br-1" v-if='environment_settings.MIX_ENABLE_LANGUAGE_SELECTION'>
						<label class="col-9 col-form-label" v-if="is_superuser() || is_admin()">{{ $t('translations.set_default_language')}}</label>
						<label class="col-9 col-form-label" v-else>{{ $t('translations.default_language')}}</label>
						<select v-if='is_superuser() || is_admin()' class="form-control col-md-7 custom-select" v-model="provider.locale" v-on:change="setLocale">
							<option :key='key' v-for="(lang, key) in $root.lookup.langs" :value="key" placeholder="language">{{ lang }}</option>
						</select>
						<span v-else class="inputViewOnly col-6">{{ provider.locale ? $root.lookup.langs[provider.locale] : "" }}</span>
					</div>

					<hr>

					<div class="form-group d-flex justify-content-between bg-white br-1">

							<div class="col-8"><label for='wait_exit_time' class="col-form-label">{{ autobrand('translations.time_requests_return_waiting')}}</label></div>
							<div class='col-6'>
								<input v-if='is_superuser() || is_admin()' type='time' placeholder='HH:MM' v-model='provider.wait_exit_time' class="form-control" style="width: 100%;">
								<span v-else class="inputViewOnly">{{this.provider.wait_exit_time}}</span>
							</div>

							<div><label for='wait_default_days' class="col-form-label">{{ $t('translations.set_waiting_days')}}</label></div>
							<div class=''>
								<input v-if='is_superuser() || is_admin()' type='number' min='1' max='28' v-model='provider.wait_default_days' class='form-control col-sm-24'>
								<span v-else class="inputViewOnly">{{this.provider.wait_default_days}}</span>
							</div>

					</div>
					<hr>

					<div class="d-flex justify-content-between">

						<label for='service_message' class="col-8 col-sm-6 col-form-label">{{ $t('translations.service_message')}}</label>
						<div style="display: block;width: 100%;">
							<textarea v-if='is_superuser() || is_admin()' class='col-24 col-sm-24  form-control' v-model='provider.service_message'></textarea>
							<span v-else class="inputViewOnly">{{ this.provider.service_message ? this.provider.service_message : "&nbsp;"}}</span>
						</div>
					</div>
					<hr>
					<div class="d-flex justify-content-between">

						<label for='service_message' class="col-10 col-form-label">{{ $t('translations.service_message_start_at')}}</label>
						<div class='d-flex flex-row align-items-start' v-if='is_superuser() || is_admin()'>
                            <datetime2 ref='sadate' v-model="provider.service_message_start_at"></datetime2>
                            
						</div>
						<span v-else class="inputViewOnly">{{this.provider.service_message_start_at | formatDateTime}}</span>
					</div>

                    <div class="d-flex justify-content-between">

						<label for='service_message' class="col-10 col-form-label">{{ $t('translations.service_message_end_at')}}</label>
						<div class='d-flex flex-row align-items-start' v-if='is_superuser() || is_admin()'>
							<datetime2 ref='eadate' v-model="provider.service_message_end_at"></datetime2>
						</div>
						<span v-else class="inputViewOnly">{{ provider.service_message_end_at | formatDateTime}}</span>
					</div>
                    <hr>
                    <div class="d-flex justify-content-between">
						<label for='default_include_internal_message' class="col-10 col-form-label">{{ $t('translations.include_internal_messages_when_copying')}}</label>
						<div class='d-flex flex-row align-items-start' v-if='is_superuser() || is_admin()'>
                            <b-form-checkbox name='default_include_internal_message' v-model="provider.default_include_internal_message" switch></b-form-checkbox>
                        </div>
						<span v-else class="inputViewOnly">{{ provider.default_include_internal_message ? this.$t('translations.yes') : this.$t('translations.no') }}</span>
					</div>
                    <div class="d-flex justify-content-between">
						<label for='include_datetime_when_copying' class="col-10 col-form-label">{{ $t('translations.include_datetime_when_copying')}}</label>
						<div class='d-flex flex-row align-items-start' v-if='is_superuser() || is_admin()'>
                            <b-form-checkbox name='include_datetime_when_copying' v-model="provider.include_datetime_when_copying" switch></b-form-checkbox>
                        </div>
						<span v-else class="inputViewOnly">{{ provider.include_datetime_when_copying ? this.$t('translations.yes') : this.$t('translations.no') }}</span>
					</div>
                    <template v-if='$root.provider.record_system_integration_type_id == 1'>
                        <inline-error type='writeback_user_id'></inline-error>
                        <div class="d-flex flex-column">
                            <label class="col col-form-label" for='name'>{{ autobrand('translations.default_writeback_user') | capitalise}}:</label>
                            <div class='col' v-if='is_superuser() || is_admin()'>
                                <select class='form-control' v-model='provider.writeback_user_id'>
                                    <option value="">-- {{ $t('translations.none')}} --</option>
                                    <template v-for='(user) in staff'>
                                        <option v-if='user.provider.mrs_user_id' :key='user.id' :value='user.id'>
                                            {{ formatNameCompliant(user) }}
                                        </option>
                                    </template>
                                </select>
                            </div>
                            <span v-else class="inputViewOnly">{{ formatNameCompliant(staff.find(obj => {return obj.user_id == provider.writeback_user_id})) }}&nbsp;</span>
                        </div>
                    </template>
<!-- REPEAT prescription -->
					<!-- <hr>
					<div class="d-flex">
						<label class="col-8 col-form-label">
							Repeat prescription link
						</label>
						<span style="position:relative;top:10px;color:grey;text-transform:italic;margin-right:10px;">https://</span>
						<input v-model='provider.repeat_prescription_link' class="form-control" type="text/url">
					</div>
					<hr> -->
				</div>
<!-- sites -->
				<div class="p-3 col-lg-7 col-md-24 col-sm-24 bg-light br-1 m-1 mb-0">
					<h3 class="d-flex justify-content-between"><span class="" >{{ autobrand('translations.patient_link') }}</span></h3>
					<p class=""><a target='patient' :href='patient_link' v-text='patient_link'></a></p>
					<hr>

					<h3>{{ $t('translations.sites')}}</h3>
					<form class="d-flex flex-row">
						<div class="flex-fill">
							<template v-for='(site, index) in provider.site'>
								<div :key='index' class="d-flex align-items-center mb-2">
									<!-- <input type='radio' name='default_site_id' :value='site.id' v-model='provider.default_site_id'> -->

									<div class="col-md-16">
										<input v-if='is_superuser() || is_admin()' type="text" v-model="provider.site[index].name" placeholder="Enter Site Name" class="form-control">
										<span v-else>{{provider.site[index].name}}</span>
									</div>
									<hr>
									<div v-if='provider.site.filter((obj) => {return obj.name != ""}).length > 1' class="col-auto ml-auto mr-3">
										<button v-if='is_superuser() || is_admin()' v-on:click.prevent='provider.site.splice(index, 1)' class="btn btn-round btn-sm btn-danger float-right">{{ $t('translations.remove_site')}}</button>
									</div>
									<hr>
								</div>
							</template>

							<div v-if='is_superuser() || is_admin()' style="background: #ccc;">
								<button v-on:click.prevent='provider.site.push({name: "", id: -new_site_count++})' class="btn btn-primary btn-outline btn-block btn-round btn-sm float-right">{{ $t('translations.add_site')}}</button>
							</div>

						</div>
					</form>

				</div>

<!-- Availability -->
				<div class="form-group p-3 col-lg-24 col-md-24 bg-white br-1 m-1">
					<h3 class="">{{ $t('translations.availability')}}</h3>
                    <inline-error type='availability_date'></inline-error>
					<div v-if="provider.availability_date" class="form-group">
						<table class="availability table">
							<tr>
								<th scope="col">{{ $t('translations.day')}}</th>
								<!-- <th scope="col">{{ capitalise($t('translations.predicted_demand'))}}</th> -->
								<th>{{ $t('translations.in_hours_service_times')}}</th>
								<th>
                                    {{ $t('translations.service_until_next_opening')}}
                                    <b-button id="service_help_popover" variant="primary">?</b-button>
                                    <b-popover target="service_help_popover" triggers="hover focus">
                                        <template slot="title">{{ $t('translations.service_until_next_opening')}}</template>
                                        <p class='pb-2'>{{ autobrand('translations.availability_until_previous_help1')}}</p>
                                        <p class='pb-2'>{{ $t('translations.availability_until_previous_help2')}}</p>
                                        <p class='pb-2'>{{ $t('translations.availability_until_previous_help3')}}</p>
                                        <p class='pb-2'>{{ $t('translations.availability_until_previous_help4')}}</p>
                                    </b-popover>
                                </th>
							</tr>
							<template v-for="(day, day_of_week) in $root.lookup.dayNames">
                                <template v-for='(date_index) in getAvailabilityIndexes(provider.availability_date, day_of_week)'>
                                    <tr :key='provider.availability_date[date_index].id + "-" + date_index' class='day_value'>
								        <td scope="row">{{day | capitalise}}</td>
								        <!-- <td>
                                            <input v-if="is_superuser() || is_admin()" type="number" min="0" class="form-control" v-model='provider.demand[date_index].demand'>
                                            <span v-else>{{provider.demand[date_index].demand}}</span>
                                        </td> -->
                                        <td>
                                            <ul>
                                                <template v-if="Array.isArray(provider.availability_date[date_index].availability_time) && provider.availability_date[date_index].availability_time.length">
                                                    <template v-if="is_superuser() || is_admin()" v-for='(time, index) in provider.availability_date[date_index].availability_time'>
                                                        <li :key='index' class='text-nowrap'>
                                                            <input type='time' :name='provider.availability_date[date_index].date_from + "-" + index + "-from"' v-model="provider.availability_date[date_index].availability_time[index].from">
                                                            -
                                                            <input type='time' :name='provider.availability_date[date_index].date_from + "-" + index + "-to"' v-model="provider.availability_date[date_index].availability_time[index].to">
                                                        </li>
                                                    </template>
                                                    <span v-else>{{provider.availability_date[date_index].availability_time[index].from }} - {{provider.availability_date[date_index].availability_time[index].to}}</span>
                                                </template>
                                            </ul>
                                        </td>
                                        <td>
                                            <template v-if='provider.availability_date[date_index].availability_time && (provider.availability_date[date_index].availability_time.length == 0 || provider.availability_date[date_index].availability_time[0].from)'>
                                                <select v-if='is_superuser() || is_admin()' v-model='provider.availability_date[date_index].available_ooh' class="form-control custom-select">
                                                    <option value='1'>{{ autobrand('translations.out_of_hours_requests')}}</option>
                                                    <option value='0'>{{ autobrand('translations.closed_to_new_requests')}}</option>
                                                </select>
                                                <span v-else>
                                                    <span v-if='provider.availability_date[date_index].available_ooh == 1'>{{ autobrand('translations.out_of_hours_requests')}}</span>
                                                    <span v-else-if='provider.availability_date[date_index].available_ooh == 0'>{{ autobrand('translations.closed_to_new_requests')}}</span>
                                                </span>
                                            </template>
                                            <template v-else>
                                                <div class='alert alert-info '>
                                                    {{ $t('translations.availability_until_previous')}}
                                                    
                                                </div>
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                            </template>
						</table>
					</div>
					

				</div>
                <div class="form-group p-3 col-lg-24 col-md-24 bg-white br-1 m-1">
					<h3 class="">{{ $t('translations.blood_pressure_ranges')}}</h3>
                    <p v-html="$t('translations.blood_pressure_ranges_help')"></p>
                    <p class='mt-2 mb-2' v-html="$t('translations.blood_pressure_ranges_and_or')"></p>
                    <p class='mt-2 mb-2' v-html="$t('translations.blood_pressure_professional')"></p>
                    
                    
                    <inline-error type='blood_pressure_.*'></inline-error>
                    <blood-pressure-range-list class='mb-1' :editable='is_superuser() || is_admin()' :value='provider.blood_pressure_range' :errors='errors' />
                </div>
					<!-- <div class="d-flex list-group-item mt-2">
						<span class="justify-content-between align-self-center">Enable appointment bookings</span>
						<label class='toggle-label-sm justify-content-between align-items-center ml-auto'>
							<input type='checkbox' />
								<span class='back'>
								<span class='toggle'></span>
								<span class='label on'>{{ $t('translations.on')}}</span>
								<span class='label off'>{{ $t('translations.off')}}</span>
							</span>
						</label>
					</div> -->

					<!--
					@todo enable gruveo to switch on/off
					<div class="p-3 col-md-12 col-sm-24">
						<h3>Enable video calls</h3>
						<div class="d-flex list-group-item">
							<span class="justify-content-between align-self-center">Enable video calls with patients</span>
							<label class='toggle-label-sm justify-content-between align-items-center ml-auto'>
								<input v-model='provider.video_status' type='checkbox' />
									<span class='back'>
									<span class='toggle'></span>
									<span class='label on'>ON</span>
									<span class='label off'>OFF</span>
								</span>
							</label>
						</div>
					</div>
					<hr> -->
					<hr>
					<div v-if="provider.messages" class="form-group bg-white">
						<h3 class="col-auto pt-3">{{ $t('translations.messages')}}</h3>
						<div class="p-3 form-group">
							<template v-for="(message, message_index) in provider.messages">

							</template>
						</div>
					</div>
				</div>

			</div>

			<footer class='container-footer text-right'>
				<!-- <button class="btn btn-success btn-round" v-on:click.prevent='save' role="button">{{ $t('translations.update_settings')}}</button> -->
<!--
				<div v-if='is_superuser()' class="d-flex justify-content-between">
					<button v-on:click="cancelUpdateDashboard()" class="btn btn-danger btn-sm btn-round">{{ $t('translations.cancel')}}</button>

					<button class="btn btn-success btn-round" v-on:click.prevent='save' role="button">{{ $t('translations.update_settings')}}</button>

				</div> -->

				<div v-if='is_superuser() || is_admin()' class="d-flex flex-row-reverse">
					<button class="btn btn-success btn-round" v-on:click.prevent='pre_save' role="button">{{ $t('translations.update_settings')}}</button>
				</div>

			</footer>

		</div>
	</div>
</template>

<script>
export default {
	props: [],
	data: function() {
		return {
			provider: {
                service_message_start_at: null, 
                service_message_end_at: null, 
                demand: [], 
                availability_date: [], 
                site: [], 
                wait_default_days: 7, 
                wait_exit_time: "10:00", 
                default_include_internal_message: true, 
                include_datetime_when_copying: true,
                blood_pressure_range: [],
                provider_url: "",
            },
			new_site_count: 0,
			errors: [],
            locale: window.default_locale,
            staff: [],
		};
    },
    watch: {
        provider_id(new_provider_id, old_provider_id) {
            this.getData();
        }
    },
    computed: {
        patient_link() {
            if(this.provider && typeof this.provider.provider_url == "string") {
                return window.location.protocol + "//" + this.provider.provider_url.replace(/(admin|provider|nhs)\./, "my.") + ((window.location.port && window.location.port !== "8443") ? `:${window.location.port}` : "") + "/?c=" + this.provider.practice_code;
            }
            return "";
        },
        provider_id: {
            get: function() {
                if(this.is_network_admin()) {
                    return this.$root.admin_provider_id;    
                }
                else {
                    return this.$root.provider.id;
                }
            }
        },
    },
	mounted() {
		this.getData();
    },
    beforeRouteUpdate (to, from, next) {
        this.checkRouteChange(to, from, next);
    },
    beforeRouteLeave(to, from, next) {
        this.checkRouteChange(to, from, next);
    },
    methods: {
        getData() {
            this.setLoading(true);
            axios.get(this.$root.apiBase + '/providers/' + this.provider_id, {})
			.then(res => {
				for (var attrname in res.data.provider) {
					//console.log("Setting " + attrname + " to " + res.data.provider[attrname]);
					this.provider[attrname] = res.data.provider[attrname];
				}
				//this.provider = res.data.provider;
				if(!this.provider.demand) {
					this.provider.demand = [];
				}
				for(var dayOfWeek = 1; dayOfWeek <= 7; dayOfWeek++) {
					if(!this.provider.demand.find(obj => {return obj.day_of_week == dayOfWeek})) {
						this.provider.demand.push({"provider_id":this.provider.id,"day_of_week":dayOfWeek,"demand":0});
					}
				}
                this.provider.default_include_internal_message = this.provider.default_include_internal_message ? true : false;
                this.provider.include_datetime_when_copying = this.provider.include_datetime_when_copying ? true : false;
                this.provider.blood_pressure_range.forEach(obj => {
                    obj.relation_and ? obj.relation_and = true : obj.relation_and = false;
                })
                if(this.is_network_admin()) {
                    axios.get(`${this.$root.apiBase}/staff?p=0&provider_id=${this.provider_id}`).then((res) => {
                        this.staff = res.data.data;
                        this.setLoading(false);
                        this.originalData = JSON.parse(JSON.stringify(this.provider));
                    })
                    .catch(error => {
                        this.setLoading(false);
                        this.handleError(error, "read");
                    });
                }
                else {
                    this.staff = this.$root.lookup.staff;
                    this.setLoading(false);
                    this.originalData = JSON.parse(JSON.stringify(this.provider));
                }
			})
			.catch(error => {
                this.setLoading(false);
				this.handleError(error, "read");
			});
        },
        checkRouteChange(to, from, next) {
            this.checkUnsaved(this.originalData, this.provider, to, from, next);
        },
        pre_save() {
            this.confirmBloodPressureModification().then(() => {
                this.save();
            })
            .catch(error => {

            });
        },
		save() {
			this.errors = [];
			this.setLoading(true);
			axios
				.put("/api/v1/providers/" + this.$root.user.provider.id, this.provider)
				.then(res => {
                    this.setLoading(false);
                    
                    this.originalData = JSON.parse(JSON.stringify(this.provider));
					this.addNotification({
						type: "success",
						content: "Provider settings updated successfully"
					});
                    // This is unavoidable, because of the way the partial dates work in the UI.
                    // There is no way to know whether a partial date has been entered.
                    //this.getData();
                    this.$refs.sadate.reset();
                    this.$refs.eadate.reset();
				})
			.catch(error => {
				this.setLoading(false);
				this.handleError(error, "update");
			});
		},
		addAvailability() {
			this.provider.availability_date.push({
				date_from: "",
				date_to: null,
				availability_time: [{}]
			});
		},
		deleteAvailability(index) {
			this.provider.availability_date.splice(index, 1);
		},
		setLocale() {
            // Vue.nextTick(() => {
            //      this.$root.setLocale(this.provider.locale);
            // });
        },
		confirmBloodPressureModification() {
            return new Promise((resolve, reject) => {
                if(this.originalData.blood_pressure_range 
                        && !Object.compare(this.originalData.blood_pressure_range, this.provider.blood_pressure_range)) {
                    this.$modal.show('dialog', {
                        title: this.autobrand('translations.blood_pressure_warning_title'),
                        text:  '<span role="alert" tabindex="0" aria-live="polite">' + this.autobrand('translations.blood_pressure_warning_text') + '</span>',
                        buttons: [
                        {
                            title: this.$t('translations.yes'),
                            handler: () => {
                                this.$modal.hide('dialog');
                                resolve();
                            },
                        },
                        {
                            title: this.$t('translations.no'),
                            handler: () => {
                                this.$modal.hide('dialog');
                                reject();
                            }
                        }]});
                }
                else {
                    resolve();
                }
            });
        }
	}
};
</script>

<style scoped>
	input[type="time"] {
		width: 46%;
	}
</style>
